(() => {
  if (document.documentElement.dataset.b2bCanOrder === 'true') return;

  const clearUrl = window.routes?.cart_clear_url || '/cart/clear.js';

  const isCheckoutControl = (element) => {
    if (!element) return false;
    if (element.name === 'checkout') return true;
    if (element.matches?.('a[href*="/checkout"]')) return true;
    return false;
  };

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter;
      const form = event.target;
      if (isCheckoutControl(submitter) || form?.querySelector?.('[name="checkout"]')) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const control = event.target.closest('a[href*="/checkout"], button[name="checkout"]');
      if (!control) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  if (document.documentElement.dataset.cartItemCount !== '0') {
    fetch(clearUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
    }).catch(() => {});
  }
})();
